import { render } from "./qa-area.vue?vue&type=template&id=9af44f2c&scoped=true"
import script from "./qa-area.vue?vue&type=script&lang=js"
export * from "./qa-area.vue?vue&type=script&lang=js"

import "./qa-area.vue?vue&type=style&index=0&id=9af44f2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af44f2c"]])

export default __exports__